import React from 'react';
import image from 'app/assets/img/coins/tether-usdt-logo.svg';

const Tether = () => {
  return <img src={image} width="18px" />;
};

export default Tether;
